
import { Component, Prop, Vue } from "vue-property-decorator";
import { Invitation } from "./interfaces";

@Component
export default class InvitationSummaryComponent extends Vue {
	@Prop({ required: true })
	invitation!: Invitation;

	@Prop({ default: false })
	full!: boolean;

	get username() {
		return this.$store.state.user;
	}
}
